module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [(_vm.salesHeaderObj.reportType === 'Invoice') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2",
    attrs: {
      "id": "billNo"
    }
  }, [_c('label', {
    attrs: {
      "for": "billNo"
    }
  }, [_vm._v("Bill No :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.billNo))])])]) : _vm._e(), _vm._v(" "), (_vm.salesHeaderObj.reportType === 'Challan') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "challanNo"
    }
  }, [_vm._v("Challan No :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.challanNo))])])]) : _vm._e(), _vm._v(" "), (_vm.salesHeaderObj.reportType === 'Order') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "orderNo"
    }
  }, [_vm._v("Order No :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.orderNo))])])]) : _vm._e(), _vm._v(" "), (_vm.salesHeaderObj.reportType == 'Return') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "returnNo"
    }
  }, [_vm._v("Return No :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.returnNo))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "referenceNumber"
    }
  }, [_vm._v("Reference No. :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.referenceNumber) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "salesDate"
    }
  }, [_vm._v("Date :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput"
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.salesDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "WarehouseName"
    }
  }, [_vm._v("Store :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.warehouse.name) + " ")])])]), _vm._v(" "), (_vm.salesHeaderObj.reportType === 'Invoice') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "WarehouseName"
    }
  }, [_vm._v("Bill Type :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.vatTypeEnum) + " ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "suppplier"
    }
  }, [_vm._v("Customer :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.account.name))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.salesHeaderObj.account.name === 'Cash'),
      expression: "salesHeaderObj.account.name==='Cash'"
    }],
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "suppplier"
    }
  }, [_vm._v("Bill To :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.account.billToName))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.salesHeaderObj.account.name != 'Cash'),
      expression: "salesHeaderObj.account.name !='Cash'"
    }],
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "suppplier"
    }
  }, [_vm._v("Address :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.address))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.salesHeaderObj.account.name != 'Cash'),
      expression: "salesHeaderObj.account.name !='Cash'"
    }],
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "suppplier"
    }
  }, [_vm._v("Vat/Pan No :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.account.panNo))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  })]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered "
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.inventoryInOutDetailList), function(pd, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.itemMaster.hsCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.rate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((pd.quantity * pd.rate).toFixed(4)) + " ")]), _vm._v(" "), _c('td', [(_vm.checkPos) ? _c('div', {
      staticClass: "p-field p-col-12 p-md-2"
    }, [_c('Button', {
      staticClass: "p-button-raised",
      attrs: {
        "icon": "pi pi-eye"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.posDetail(pd.itemMaster.id)
        }
      }
    })], 1) : _vm._e()])])])
  })], 2), _vm._v(" "), (this.extraExpensesList.length > 0) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', [_vm._v("Extra Expenses:")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered ",
    staticStyle: {
      "margin-top": "2%"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.extraExpensesList), function(expenses, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.expensesName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.extraExpenseAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.applyVat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.debitAccountName) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.creditAccountName) + " ")])])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Narration")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesHeaderObj.remarks),
      expression: "salesHeaderObj.remarks"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.salesHeaderObj.remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salesHeaderObj, "remarks", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Amount in word")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesHeaderObj.amountInWords),
      expression: "salesHeaderObj.amountInWords"
    }],
    staticStyle: {
      "border": "none",
      "resize": "none",
      "width": "100%",
      "font-size": "12px"
    },
    attrs: {
      "type": "text",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.salesHeaderObj.amountInWords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salesHeaderObj, "amountInWords", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), (_vm.salesHeaderObj.reportType === 'Invoice') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "subttotal"
    }
  }, [_vm._v("Subtotal: " + _vm._s((_vm.salesHeaderObj.subTotalAmount).toFixed(4)) + " ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "discountAmt"
    }
  }, [_vm._v("Discount Amt: " + _vm._s((_vm.salesHeaderObj.discountAmt).toFixed(4)))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "nontaxable"
    }
  }, [_vm._v("Non-taxable:" + _vm._s((_vm.salesHeaderObj.nonTaxableAmount).toFixed(4)))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "taxable"
    }
  }, [_vm._v("Taxable:" + _vm._s((_vm.salesHeaderObj.taxableAmount).toFixed(4)))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "tax"
    }
  }, [_vm._v("Tax(13%):" + _vm._s((_vm.salesHeaderObj.vatAmount).toFixed(4)))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "total"
    }
  }, [_vm._v("Total:" + _vm._s((_vm.salesHeaderObj.totalBillAmount).toFixed(4)))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "icon": "pi pi-refresh",
      "label": "Back"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.back()
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-col-12"
  }, [_c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Pos Detail",
      "closable": false,
      "visible": _vm.showPosDialog,
      "modal": true,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.showPosDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('DataTable', {
    ref: "po",
    staticClass: "p-datatable-responsive p-datatable-customers",
    attrs: {
      "value": _vm.posDetailList,
      "paginator": true,
      "rows": 8,
      "filters": _vm.filters,
      "data-key": "id",
      "selection": _vm.selectedProduct1,
      "selectionMode": "single"
    },
    on: {
      "update:selection": function($event) {
        _vm.selectedProduct1 = $event
      }
    }
  }, [_c('Column', {
    attrs: {
      "header": "S.N",
      "field": ""
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Bill No",
      "sortable": true,
      "field": "billNo",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['billNo']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'billNo', $$v)
            },
            expression: "filters['billNo']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Customer Name",
      "sortable": true,
      "field": "customerName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['customerName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'customerName', $$v)
            },
            expression: "filters['customerName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Contact Number",
      "sortable": true,
      "field": "contactNumber",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['contactNumber']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'contactNumber', $$v)
            },
            expression: "filters['contactNumber']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Sales Qty",
      "sortable": true,
      "field": "salesQty",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['salesQty']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'salesQty', $$v)
            },
            expression: "filters['salesQty']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Selling Price",
      "sortable": true,
      "field": "sellingPrice",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['sellingPrice']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'sellingPrice', $$v)
            },
            expression: "filters['sellingPrice']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Total",
      "sortable": true,
      "field": "total",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['total']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'total', $$v)
            },
            expression: "filters['total']"
          }
        })]
      },
      proxy: true
    }])
  })], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Item Name")]), _vm._v(" "), _c('th', [_vm._v("Hs Code")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Rate")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Vatable")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Debit Account")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Credit Account")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61cd8262"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/salesReport/salesDetailReport.vue
// module id = 2270
// module chunks = 0